<div class="login-container">
    <!-- Header Logos -->
    <div class="header-logos">
        <div
            class="h-20 w-20 flex items-center justify-center p-2 backdrop-blur-sm bg-white/10 rounded-2xl border border-white/20 shadow-2xl">
            <img src="/assets/tridel.png" alt="Tridel Logo" class="max-w-full max-h-full object-contain drop-shadow-lg">
        </div>
        <div
            class="h-20 w-20 rounded-full bg-white/90 p-1.5 shadow-2xl border border-white/40 flex items-center justify-center overflow-hidden">
            <img src="/assets/niot.png" alt="NIOT Logo" class="max-w-full max-h-full object-contain">
        </div>
    </div>

    <div class="scene">
        <div class="card" [class.is-flipped]="isFlipped">
            
            <!-- Login Front Card -->
            <div class="card-face card-face-front">
                <div class="logo-section">
                    <div class="logo-icon">
                        <i class="fa-solid fa-user-shield"></i>
                    </div>
                    <h1 class="title">TERRA AXIS</h1>
                </div>

                <form (submit)="onLogin($event)" #loginForm="ngForm" novalidate>
                    <div class="form-group">
                        <label class="label">Email Address</label>
                        <div class="input-wrapper">
                            <input type="email" name="email" [(ngModel)]="email" class="input" placeholder="name@company.com" required email>
                            <i class="fa-solid fa-envelope"></i>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="label">Password</label>
                        <div class="input-wrapper">
                            <input [type]="showPassword ? 'text' : 'password'" name="password" [(ngModel)]="password" class="input"
                                placeholder="••••••••" required>
                            <i class="fa-solid fa-lock"></i>
                            <button type="button" class="toggle-password" (click)="showPassword = !showPassword">
                                <i class="fa-solid" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                            </button>
                        </div>
                        <p class="password-hint">Min 8 chars: 1 Upper, 1 Number, 1 Special Char</p>
                    </div>

                    <div class="actions">
                        <button type="button" class="link-btn" (click)="toggleFlip()">Forgot Password?</button>
                    </div>

                    <!-- Removed the on-screen error-msg as requested, using toastr instead -->
                    <button type="submit" class="btn-primary" [disabled]="isLoading || !loginForm.valid">
                        <span *ngIf="!isLoading">Login</span>
                        <i *ngIf="!isLoading" class="fa-solid fa-right-to-bracket"></i>
                        <i *ngIf="isLoading" class="fa-solid fa-circle-notch fa-spin"></i>
                    </button>
                </form>

                <div class="footer">
                    <p><b>Authorized Access Only.</b></p>
                </div>
            </div>

            <!-- Forgot Password Back Card -->
            <div class="card-face card-face-back">
                <div class="logo-section">
                    <div class="logo-icon">
                        <i class="fa-solid fa-key"></i>
                    </div>
                    <h1 class="title">RESET</h1>
                </div>

                <div *ngIf="!emailVerified">
                    <div class="form-group">
                        <label class="label">Verification Email</label>
                        <div class="input-wrapper">
                            <input type="email" name="forgotEmail" [(ngModel)]="forgotEmail" class="input" placeholder="name@company.com" required email>
                            <i class="fa-solid fa-envelope"></i>
                        </div>
                    </div>
                    <p *ngIf="resetError" class="error-msg fade-in">{{resetError}}</p>
                    <button class="btn-primary" (click)="verifyEmail()" [disabled]="isLoading || !forgotEmail">
                        <span *ngIf="!isLoading">Verify Email</span>
                        <i *ngIf="isLoading" class="fa-solid fa-circle-notch fa-spin"></i>
                    </button>
                </div>

                <div *ngIf="emailVerified" class="fade-in">
                    <div class="form-group">
                        <label class="label">New Password</label>
                        <div class="input-wrapper">
                            <input [type]="showNewPassword ? 'text' : 'password'" name="newPassword" [(ngModel)]="newPassword" class="input"
                                placeholder="••••••••" required minlength="8">
                            <i class="fa-solid fa-lock"></i>
                            <button type="button" class="toggle-password" (click)="showNewPassword = !showNewPassword">
                                <i class="fa-solid" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                            </button>
                        </div>
                        <p class="password-hint">Min 8 chars: 1 Upper, 1 Number, 1 Special Char</p>
                    </div>
                    <div class="form-group">
                        <label class="label">Confirm New Password</label>
                        <div class="input-wrapper">
                            <input [type]="showConfirmPassword ? 'text' : 'password'" name="confirmPassword" [(ngModel)]="confirmPassword"
                                class="input" placeholder="••••••••" required>
                            <i class="fa-solid fa-lock"></i>
                            <button type="button" class="toggle-password" (click)="showConfirmPassword = !showConfirmPassword">
                                <i class="fa-solid" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                            </button>
                        </div>
                    </div>
                    <p *ngIf="resetError" class="error-msg fade-in">{{resetError}}</p>
                    <p *ngIf="newPassword && confirmPassword && newPassword !== confirmPassword" class="error-msg fade-in">Passwords do not
                        match</p>
                    
                    <button class="btn-primary" (click)="onResetPassword()"
                        [disabled]="isLoading || !newPassword || newPassword !== confirmPassword || newPassword.length < 8">
                        <span *ngIf="!isLoading">Set New Password</span>
                        <i *ngIf="isLoading" class="fa-solid fa-circle-notch fa-spin"></i>
                    </button>
                </div>

                <div class="actions" style="margin-top: 20px; justify-content: center;">
                    <button type="button" class="link-btn" (click)="toggleFlip()">
                        <i class="fa-solid fa-arrow-left"></i> Back to Login
                    </button>
                </div>

                <div class="footer">
                    <p><b>Authorized Access Only.</b></p>
                </div>
            </div>

        </div>
    </div>
<div
    class="absolute bottom-5 right-5 text-[8px] font-black text-white/40 uppercase tracking-widest z-[100] pointer-events-none select-none">
    &copy; {{currentYear}} Tridel Technologies. Authorized Access Only.
</div>
</div>
